import { Component, inject, OnInit } from '@angular/core';
import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { SelectButtonModule } from 'primeng/selectbutton';
import { OfferTargetAudienceFormGroup } from '@app/areas/offers/services/offer.form.service';
import { WinBackPeriod } from '@app/areas/offers/forms/offer-audience-form/offer-audience-filter.types';

interface SelectOption<T> {
  label: string;
  value: T;
}

@Component({
  selector: 'app-offer-audience-win-back-form',
  templateUrl: './offer-audience-win-back-form.component.html',
  styleUrls: ['./offer-audience-win-back-form.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, NgIf, SelectButtonModule],
})
export class OfferAudienceWinBackFormComponent implements OnInit {
  private readonly controlContainer = inject(ControlContainer);

  protected winBackForm: OfferTargetAudienceFormGroup['controls']['WinBackConfig'] | null = null;

  protected inactivityPeriodOptions: SelectOption<WinBackPeriod>[] = [
    { label: '30 Days', value: '30days' },
    { label: '60 Days', value: '60days' },
    { label: '90 Days', value: '90days' },
  ];

  ngOnInit(): void {
    this.winBackForm = this.controlContainer.control as OfferTargetAudienceFormGroup['controls']['WinBackConfig'];
  }
}
